import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { renderInstructionWithLinks } from "../components/inputInstructionsHover";

const StyledDialog = styled(Dialog)`
  .p-dialog-content {
    padding: 2rem;
    display: flex;
    flex-direction: column;
  }

  a {
    color: var(--sumi-blue);
    text-decoration: underline;
  }
`;

const NoticeText = styled.p`
  white-space: pre-line;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

interface PpwrNoticeDialogProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
}

const PpwrNoticeDialog: React.FC<PpwrNoticeDialogProps> = ({
  show,
  onHide,
  onAccept,
}) => {
  const { t } = useTranslation();

  return (
    <StyledDialog
      header={t("header-ppwr-notice")}
      visible={show}
      onHide={onHide}
      style={{ width: "500px" }}
      closable={false}
    >
      <NoticeText>
        {renderInstructionWithLinks(t("text-ppwr-notice"))}
      </NoticeText>

      <ButtonContainer>
        <Button label={t("cmd-continue")} onClick={onAccept} />
      </ButtonContainer>
    </StyledDialog>
  );
};

export default PpwrNoticeDialog;
